<script>
import { useAlert } from 'dashboard/composables';
import { mapGetters } from 'vuex';
import PixelForm from './PixelForm.vue';

export default {
  components: { PixelForm },
  props: {
    value: {
      type: Object,
      required: true,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters({ uiFlags: 'metaCapiPixels/getUIFlags' }),
  },
  methods: {
    async onSubmit(pixel) {
      try {
        await this.$store.dispatch('metaCapiPixels/update', {
          meta_capi_pixel: pixel,
          id: this.id,
        });
        useAlert(this.$t('META_CAPI_PIXELS.EDIT.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        const alertMessage =
          error?.response?.data?.message ||
          this.$t('META_CAPI_PIXELS.EDIT.API.ERROR_MESSAGE');
        useAlert(alertMessage);
      }
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header
      :header-title="$t('META_CAPI_PIXELS.EDIT.TITLE')"
    />
    <PixelForm
      :value="value"
      :is-submitting="uiFlags.updatingItem"
      :submit-label="$t('META_CAPI_PIXELS.FORM.EDIT_SUBMIT')"
      @submit="onSubmit"
      @cancel="onClose"
    />
  </div>
</template>
